import {
  ActiveUserAvatar,
  createStackHeaderNavigator,
  ModalCloseButton,
  RootDrawerToggle,
} from "@towersystems/roam-common-native";
import { SettingsRootParamList } from "../../../types";
import { Colors, Spacings } from "react-native-ui-lib";
import { CardStyleInterpolators } from "@react-navigation/stack";
import { BackgroundEraserSettingsRootScreen } from "./BackgroundEraserSettingsRootScreen";
import { SettingsScreen } from "./SettingsScreen";

const SettingDrawer = createStackHeaderNavigator<SettingsRootParamList>();

export const SettingsRootScreen = () => {
  return (
    <SettingDrawer.Navigator
      screenOptions={{
        title: "",
        cardStyle: { height: "100%", backgroundColor: Colors.surface },
        headerLeftContainerStyle: { paddingLeft: Spacings.s5 },
        headerRightContainerStyle: { paddingRight: Spacings.s5 },
        headerTintColor: Colors.text,
        headerTitleAlign: "center",
        headerStyle: {
          backgroundColor: Colors.surface,
          borderBottomWidth: 1,
          borderBottomColor: Colors.borderColor,
        },
      }}
    >
      <SettingDrawer.Group
        screenOptions={{
          title: "",
          animationEnabled: true,
          cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
          headerLeft: () => <RootDrawerToggle />,
        headerRight: () => <ActiveUserAvatar />,
        }}
      >
        <SettingDrawer.Screen
          name="SettingsScreen"
          component={SettingsScreen}
        />
      </SettingDrawer.Group>
      <SettingDrawer.Group
        screenOptions={{
          headerShown: false,
          animationEnabled: true,
          title: "",
          cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
        }}
      >
        <SettingDrawer.Screen
          name="BackgroundEraserSettingsRootScreen"
          component={BackgroundEraserSettingsRootScreen}
        />
      </SettingDrawer.Group>
    </SettingDrawer.Navigator>
  );
};
